import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ORDER = [
  { perm: "dashboard.read", path: "/dashboard" },
  { perm: "finance.read", path: "/finance" },
  { perm: "inkoop.read", path: "/inkoop" },
  { perm: "returns.read", path: "/returns" },
  { perm: "voorraad.read", path: "/inkoop/voorraad" },
  { perm: "overrides.read", path: "/overrides" },
  { perm: "costs.read", path: "/finance/overheadkosten" },
  { perm: "marketing.read", path: "/finance/marketingkosten" },
];

/** Stuur user naar eerste pagina waarvoor hij permissie heeft. */
export function RoleHome() {
  const { user, hasPerm } = useAuth();

  // Partner_nod-users gaan direct naar de eigen portal. Check op ROLE,
  // niet hasPerm("partner_nod.portal_view") — owners (is_owner=true) krijgen
  // van hasPerm() alles automatisch true en zouden anders óók naar het
  // NOD-portal worden gestuurd, terwijl ze juist Merkatura-admin willen.
  if (user?.role === "partner_nod") {
    return <Navigate to="/nod-portal/stock" replace />;
  }

  const target = ORDER.find((o) => hasPerm(o.perm))?.path ?? "/login";
  return <Navigate to={target} replace />;
}
